export default "__VITE_ASSET__vps7gIUr__"